import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import TopBar from '../common/TopBar';
import { useGetOrganizations } from '../hooks/tanstack/useOrganizationHook';
import { useGetUser } from '../hooks/tanstack/useUserHook';
import { useGetRouteParams } from '../hooks/tanstack/useUtilsHook';
import useUserStore from '../hooks/zustand/useUserStore';
import routes from '../routes';
import { useCurrentOrganization } from '../utils/helpers';

import AccountSetupDialog from './AccountSetupDialog';

const ProtectedRoute = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const { orgId } = useGetRouteParams();

  const [openAccountSetupDialog, setOpenAccountSetupDialog] = useState(false);

  const { data: currentUser, isFetchedAfterMount } = useGetUser();

  const { data: organizations } = useGetOrganizations();

  const { data: currentOrg, isFetched } = useCurrentOrganization();

  const navigate = useNavigate();

  const setOrgUsers = useUserStore((state) => state.setOrgUsers);

  const currentPage = currentPath.split('/')[currentPath.split('/').length - 1];

  useEffect(() => {
    if (!currentUser && isFetchedAfterMount) {
      navigate('/login');
      return;
    }

    if (!currentUser || currentPage === 'settings' || !isFetched) {
      return;
    }

    if (organizations?.length === 0) {
      navigate('/' + routes.organization.invitations);
      return;
    }

    const currentOrgId = currentOrg?.id;

    if (currentOrgId && !orgId) {
      setOrgUsers({
        id: currentUser.id,
        orgId: currentOrgId,
      });

      navigate(`/${currentOrgId}/projects/`);
      return;
    }

    if (
      isFetchedAfterMount &&
      (!currentUser.first_name || !currentUser.last_name)
    ) {
      setOpenAccountSetupDialog(true);
      return;
    }
  }, [
    currentOrg,
    organizations,
    isFetchedAfterMount,
    orgId,
    currentPage,
    isFetched,
  ]);

  if (!currentUser) {
    return <></>;
  }

  return (
    <div className="flex">
      <div className="w-full">
        <header className="sticky top-0 z-50 w-full">
          <TopBar />
        </header>
        <Outlet />
      </div>
      <AccountSetupDialog
        open={openAccountSetupDialog}
        title={'Set up your account'}
        handleCloseDialog={() => setOpenAccountSetupDialog(false)}
      />
    </div>
  );
};

export default ProtectedRoute;
